import {
  useEmbedConfigureStore,
  type IComponentSettings,
  type IEmbedLanguage
} from '@/stores/embeds/embedConfigure.store'
import { useIdeStore } from '@/stores/embeds/ide.store'
import { JDOODLEBLOCKSNAMES } from '@/utils/embeds/editorMeta'
import { type IMeta } from '@/utils/meta'
/**
 * On select language change
 * @param versionIndex - The version index to set
 */
const onSelectVersionChange = (versionIndex: number) => {
  useIdeStore().setSelectedVersion(versionIndex)
}
/**
 * On setting change
 */
const onSettingChange = () => {
  const settongs = useEmbedConfigureStore().getComponentSettings?.find(
    (componentSetting: IComponentSettings) =>
      componentSetting.componentName === JDOODLEBLOCKSNAMES.VERSIONLIST
  )?.configStyle
  const hideTitle = settongs?.find((setting) => setting.id === 'hideTitle')?.value || 'true'
  useIdeStore().setVersionListHideTitle(hideTitle === 'true' || false)
  const titleName =
    settongs?.find((setting) => setting.id === 'titleName')?.value || 'Select Version'
  useIdeStore().setVersionListTitleName(titleName)
  const display = settongs?.find((setting) => setting.id === 'display')?.value || 'true'
  useIdeStore().setVersionListDisplay(display === 'true' || false)
}
/**
 * Init language version list
 */
const initVersionList = () => {
  const selectedLanguageObj: IEmbedLanguage = useIdeStore().selectedLanguage as IEmbedLanguage
  const selectedLanguage = selectedLanguageObj.language as string
  const langMeta: IMeta = useEmbedConfigureStore().getLanguageMeta[selectedLanguage] as IMeta
  const langVersion = langMeta?.versions || []
  useIdeStore().setSelectedLanguageVersionsList(langVersion)
  const versionIndex = selectedLanguageObj.versionIndex || 0
  onSelectVersionChange(versionIndex)
}
/**
 * Destroy language version list
 */
const destroyVersionList = async () => {
  await new Promise((resolve) => setTimeout(resolve, 100))
  const selectedLanguageObj: IEmbedLanguage = useIdeStore().selectedLanguage as IEmbedLanguage
  if (!selectedLanguageObj) return
  const selectedLanguage = selectedLanguageObj.language as string
  const langMeta: IMeta = useEmbedConfigureStore().getLanguageMeta[selectedLanguage] as IMeta
  const langVersion = langMeta?.versions || []
  useIdeStore().setSelectedLanguageVersionsList(langVersion)
  const versionIndex = selectedLanguageObj.versionIndex || 0
  onSelectVersionChange(versionIndex)
}
export default {
  destroyVersionList,
  initVersionList,
  onSettingChange,
  onSelectVersionChange
}
